export const KNOWLEDGE_BASE_TYPE = 'base' as const;
export const KNOWLEDGE_HUB_TYPE = 'hub' as const;
export const KNOWLEDGE_HUB_NESTED_TYPE = 'hub-nested' as const;

export const SETTINGS_IDS = {
	DETAILS: 'details',
	PEOPLE: 'people',
	SUMMARY: 'summary',
	VIRTUAL_AGENT: 'virtual-agent',
	DELETE_PROJECT: 'delete-project',
	ISSUE_LAYOUT: 'issue-layout',
	ISSUE_TYPES: 'issue-types',
	ITSM_FEATURES: 'itsm-features',
	FEATURES: 'features',
	REQUEST_TYPES: 'sd-request-types',
	TICKET_TYPES: 'sd-ticket-types',
	CUSTOMER_PERMISSIONS: 'sd-customer-permissions',
	LANGUAGE_SUPPORT: 'sd-language-support',
	PORTAL_SETTINGS: 'sd-portal-settings',
	EMAIL_REQUESTS: 'sd-email-requests',
	CUSTOMER_NOTIFICATIONS: 'sd-customer-notifications',
	PROJECT_WIDGET_ADDON: 'sd-project-widget-addon',
	PROJECT_WIDGET_ADDON_INSTALLER: 'sd-project-widget-addon-installer',
	PROJECT_ASSETS_AD: 'sd-project-assets-ad',
	SATISFACTION_SETTINGS: 'sd-satisfaction-settings',
	KNOWLEDGE_BASE: 'sd-knowledge-base',
	SLAS: 'sd-slas',
	AUTOMATION: 'sd-automation',
	PLAYBOOKS: 'playbooks',
	JIRA_AUTOMATION: 'jira-automation',
	AUTOMATION_SUB_NAV: 'sd-automation-sub-nav',
	DEVTOOLS: 'devtools',
	JSD_APP_DISCOVERY: 'sd-app-discovery',
	JSD_INCIDENT_MANAGEMENT: 'sd-incident-management',
	JSD_CHANGE_MANAGEMENT: 'sd-change-management',
	WORKFLOWS: 'workflows',
	SCREENS: 'screens',
	FIELDS: 'fields',
	VERSIONS: 'versions',
	COMPONENTS: 'components',
	PERMISSIONS: 'permissions',
	ISSUE_SECURITY: 'issue-security',
	NOTIFICATIONS: 'notifications',
	NOTIFICATION_EMAIL: 'notification-email',
	ISSUE_COLLECTORS: 'issue-collectors',
	PROJECT_CHAT_ADDON: 'sd-project-chat-addon',
	FORMS: 'proforma-forms',
	EXTERNAL_LINKS: 'sd-external-links',
	DATA_CLASSIFICATIONS: 'data-classificatons',
	JOURNEYS: 'journeys',
} as const;

export const NG_COMMUNITY_LINK =
	'https://community.atlassian.com/t5/Next-gen-Jira-Service-Desk/gp-p/next-gen-jsd';

export const SERVICE_DESK_LEGACY_TICKET_TYPES = 'project/service-desk/legacy-ticket-types' as const;
export const SERVICE_DESK_AUTOMATION_SUB_NAV =
	'project/service-desk/settings/automation-sub-nav' as const;
export const MENU_ID_SD = 'project/service-desk';
export const MENU_ID_SD_ITSM = 'project/service-desk-itsm';

export const SECTION_ID = {
	ISSUES: 'issues',
	QUEUES: 'queues',
	REPORTS: 'reports',
	INSIGHT: 'insight',
	KNOWLEDGE: 'knowledge',
	SETTINGS: 'settings',
} as const;

export const JIRA_AUTOMATION_ADDON_KEY = 'com.codebarrel.addons.automation';
export const JIRA_FEDRAMP_MODERATE_AUTOMATION_ADDON_KEY =
	'com.codebarrel.addons.automation.moderate';
/**
 * @deprecated This is related to the unused `shifter` property functionality. Do not migrate to Nav4, unless we find out its functionality: https://atlassian.slack.com/archives/C06PDP3LZ25/p1720419402663749
 */
export const PROJECT_SETTINGS_SHIFTER_WEIGHT = 200;

export const FEEDBACK_GROUP_ID = 'jira-servicedesk-itsm-sidebar-nav';

export const packageName = 'jiraNavigationAppsSidebarServicedesk';
